export const ROUTES = {
	EMPTY_PATH: '/',
	DASHBOARD: '/dashboard',
	JOB_CONFIGURATION: '/jobConfiguration',
	UPLOAD_INGREDIENT: '/uploadIngredient',
	RELEASE_PACKAGE: '/releasePackage',
	FARM_REPOSITORY: '/farmRepository',
	VNC_VIEWER: '/vncViewer',
};
